<div class="toast-overlay" *ngIf="toast" [class.visible]="isVisible" [class.success]="toast.type === 'success'"
    [class.error]="toast.type === 'error'">
    <div class="toast-content">
        <div class="icon-wrapper" *ngIf="toast.type === 'success'">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
        </div>
        <div class="icon-wrapper" *ngIf="toast.type === 'error'">
            <svg class="cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="cross-circle" cx="26" cy="26" r="25" fill="none" />
                <path class="cross-line" fill="none" d="M16 16 36 36" />
                <path class="cross-line" fill="none" d="M36 16 16 36" />
            </svg>
        </div>
        <span class="message">{{ toast.message }}</span>
    </div>
</div>